import React, {
	Component
} from 'react';
import './App.css';
import RoutingConfig from './Routing/RoutingConfig';
import {
	Provider
} from 'react-redux';
import Header from './Components/Header/Header';
import configureStore from './Store/configureStore';
const store = configureStore();
class App extends Component {
	render() {

		return (
			<Provider store={store}>
				<div className="App">
					<Header />
					<RoutingConfig />
				</div>
			</Provider>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js